// 之前的老webIM的下发电商场景订单
// export const robotGoodsNav = [
//   {
//     xml: `
//       <?xml version="1.0" encoding="utf-8"?>
//       <msg brief="企点结构化消息" serviceID="115" background="#FFFFFFFF">
//           <linear background="#FFFFFFFF" orientation="vertical">
//               <linear margin="0,0,0,2" margin.pc="0,0,0,1">
//                   <linear action="browser" actionData="https://www.google.com">
//                       <image width="286" height="286" width.pc="143" height.pc="143" src="https://wiki.supercombo.gg/images/b/bf/Kof97logo.png"/>
//                   </linear>
//                   <linear margin="2,0,0,0" margin.pc="1,0,0,0" action="browser" actionData="https://www.youtube.com">
//                       <image width="284" height="286" width.pc="142" height.pc="143" src="https://wiki.supercombo.gg/images/b/bf/Kof97logo.png"/>
//                   </linear>
//               </linear>
//               <linear margin="0,0,0,2" margin.pc="0,0,0,1">
//                   <linear action="browser" actionData="https://www.google.com">https://wiki.supercombo.gg/images/b/bf/Kof97logo.png"/>
//                   </linear>
//                   <linear margin="2,0,0,0" margin.pc="1,0,0,0" action="browser" actionData="https://www.youtube.com">
//                       <image width="284" height="286" width.pc="142" height.pc="143" src="https://wiki.supercombo.gg/images/b/bf/Kof97logo.png"/>
//                   </linear>
//               </linear>
//               <linear action="browser" actionData="https://www.baidu.com" actionData.pc="{{ list[0].jumpURLMore }}">
//                   <linear orientation="vertical" margin="24,20,24,24" margin.pc="12,10,12,12">
//                       <text width="524" size="32" width.pc="262" size.pc="14" color="#FF262d3d"
//                        color.pc="0xFF262d3d" style="bold" maxLine="1" text="啊打开就是圣诞节哈是" />
//                       <text width="524" margin="0,16,0,0" size="28" width.pc="262" margin.pc="0,8,0,0"
//                       size.pc="10" color="#FF262d3d" color.pc="0xFF262d3d" maxLine="2"
//                       text="阿斯科利大家开始的空间啊圣诞节啊睡觉都睡了" />
//                   </linear>
//               </linear>
//           </linear>
//       </msg>
//       `,
//     json: null,
//   },
//   {
//     xml: `<?xml version="1.0" encoding="utf-8"?>
//     <msg brief="企点结构化消息" background="#FFFFFFFF" displayType="bigCard">\r\n
//         <linear background="#FFFFFFFF" width="-1" orientation="vertical">
//             <image width="-1" height="280" src="https://aaa.com/a.png"/>
//             <linear width="-1" weight="1" height="-2" orientation="vertical" padding="24,20,24,24">
//                 <text size="32" color="#FF262d3d" style="bold" maxLine="1" text="下单专属权益" />
//                 <text margin="0,16,0,0" size="24" color="#FF262d3d" text="" />
//             </linear>
//         </linear>
//     </msg>`,
//     json: null,
//   },
//   {
//     xml: '',
//     json: [
//       {
//         id: '1',
//         title: '智能手表1111',
//         currencyUnit: '$',
//         indicate: '4G全网通｜八重安全定位',
//         price: '999.99',
//         inventory: '20',
//         sales: '5',
//         image: 'http://image.it168.com/n/640x480/4/4869/4869316.jpg',
//         jumpURL: 'https://item.jd.com/100011203359.html',
//       },
//       {
//         id: '2',
//         title: '智能手表222',
//         currencyUnit: '$',
//         indicate: '4G全网通｜八重安全定位',
//         price: '999.99',
//         inventory: '20',
//         sales: '5',
//         image: 'http://image.it168.com/n/640x480/4/4869/4869316.jpg',
//         jumpURL: 'https://item.jd.com/100011203359.html',
//       },
//       {
//         id: '3',
//         title: '智能手表3',
//         currencyUnit: '$',
//         indicate: '4G全网通｜八重安全定位',
//         price: '999.99',
//         inventory: '20',
//         sales: '5',
//         image: 'http://image.it168.com/n/640x480/4/4869/4869316.jpg',
//         jumpURL: 'https://item.jd.com/100011203359.html',
//       },
//       {
//         id: '4',
//         title: '智能手表4',
//         currencyUnit: '$',
//         indicate: '4G全网通｜八重安全定位',
//         price: '999.99',
//         inventory: '20',
//         sales: '5',
//         image: 'http://image.it168.com/n/640x480/4/4869/4869316.jpg',
//         jumpURL: 'https://item.jd.com/100011203359.html',
//       },
//     ],
//   },
// ];
// 优惠券
export const robotCouponXml = `<?xml version="1.0" encoding="utf-8"?>
<msg brief="企点结构化消息" serviceID="115" background="#FFFFFFFF">
    <linear background="#FFFFFFFF" width="-2" height="-2" orientation="vertical">
        <linear width="-2" height="-2" margin.mobile="24,20,24,20" margin.pc="12,10,12,10" margin.web="24,20,24,20"
            action="browser" actionData="   " >
            <image name="onlineCoupon0" width.mobile="132" height.mobile="112" margin.mobile="0,0,20,0" width.pc="66" height.pc="56" margin.pc="0,0,10,0" width.web="132" height.web="112" margin.web="0,0,20,0" src="https://aaa.com/a.png"></image>
            <linear width="-2" height="-2" orientation="vertical" platform="web">
                <linear width="-2" height="-2" margin="0,0,0,20" orientation="horizontal"
                    gravity="centerHorizontal|centerVertical">
                    <linear width="76" height="32" background="#FFFFF7F0" borderWidth="1" borderColor="#FFFFEBDC"
                       borderStyle="solid" cornerRadius="6" gravity="centerHorizontal|centerVertical">
                        <text width="-2" height="-2" size="20" style="bold" color="#FFFF8345" text="店铺劵"></text>
                    </linear>
                    <text height="-2" width="284" margin="12,0,0,0" size="26"
                      width.pc="142" margin.pc="6,0,0,0" size.pc="8" color="#FF262D3D"
                      color.pc="0xFF262D3D" maxLine="1" text="优惠券111"
                      gravity="centerHorizontal|centerVertical"></text>
                </linear>
                <linear width="-2" height="-2" gravity="left|bottom" orientation="horizontal">
                    <text height="-2" width="216" margin="0,0,12,0" size="22" maxLine="1"
                    text="2021.01.02前使用" color="#FFA1ABC2"></text>
                    <linear width="140" height="52" borderWidth="1" borderColor="#FF7396FF"
                      borderStyle="solid" cornerRadius="30" gravity="centerHorizontal|centerVertical">
                        <text width="-2" height="-2" size="26" text="点击领取" color="#FF4A70FF"></text>
                    </linear>
                </linear>
            </linear>
        </linear>
        <linear width="-2" height="-2" margin.mobile="24,20,24,20" margin.pc="12,10,12,10"
           margin.web="24,20,24,20" action="browser" actionData="   " >
            <image name="onlineCoupon1" width.mobile="132" height.mobile="112" margin.mobile="0,0,20,0" width.pc="66" height.pc="56" margin.pc="0,0,10,0" width.web="132" height.web="112" margin.web="0,0,20,0" src="https://aaa.com/a.png"></image>
            <linear width="-2" height="-2" orientation="vertical" platform="web">
                <linear width="-2" height="-2" margin="0,0,0,20" orientation="horizontal"
                    gravity="centerHorizontal|centerVertical">
                    <linear width="76" height="32" background="#FFFFF7F0" borderWidth="1" borderColor="#FFFFEBDC"
                     borderStyle="solid" cornerRadius="6" gravity="centerHorizontal|centerVertical">
                        <text width="-2" height="-2" size="20" style="bold" color="#FFFF8345" text="店铺劵"></text>
                    </linear>
                    <text height="-2" width="284" margin="12,0,0,0" size="26" width.pc="142"
                     margin.pc="6,0,0,0" size.pc="8" color="#FF262D3D" color.pc="0xFF262D3D"
                     maxLine="1" text="优惠券122" gravity="centerHorizontal|centerVertical"></text>
                </linear>
                <linear width="-2" height="-2" gravity="left|bottom" orientation="horizontal">
                    <text height="-2" width="216" margin="0,0,12,0" size="22" maxLine="1" text="2021.01.02前使用"
                     color="#FFA1ABC2"></text>
                    <linear width="140" height="52" borderWidth="1" borderColor="#FF7396FF" borderStyle="solid"
                     cornerRadius="30" gravity="centerHorizontal|centerVertical">
                        <text width="-2" height="-2" size="26" text="点击领取" color="#FF4A70FF"></text>
                    </linear>
                </linear>
            </linear>
        </linear>
    </linear>
</msg>`;
// 图文通知
export const robotGraphicNotice = `<?xml version="1.0" encoding="utf-8"?>
<msg brief="企点结构化消息" serviceID="115" background="#FFFFFFFF" action="browser" actionData="https://www.baidu.com/?_need_qd_trans_info=1">
    <linear background="#FFFFFFFF" orientation="vertical">
        <image name="onlineBanner" width="620" height="304" width.pc="310" height.pc="152" src="https://wiki.supercombo.gg/images/b/bf/Kof97logo.png"/>
        <linear width="-2" height="-2">
            <linear width="-2" height="-2" orientation="vertical" margin="24,20,24,24" margin.pc="12,10,12,12">
                <text width="572" height="-2" size="32" width.pc="286" size.pc="12" color="#FF262d3d" color.pc="0xFF262d3d" style="bold" maxLine="1" text="下单专属权益" />
                <text width="572" height="-2" margin="0,16,0,0" size="24" width.pc="286" margin.pc="0,8,0,0" size.pc="6" color="#FF262d3d" color.pc="0xFF262d3d" maxLine="2" text="点我下单，查看详情" />
            </linear>
        </linear>
    </linear>
</msg>`;

// 多宫格列表
export const robotGoodsActive = `<?xml version="1.0" encoding="utf-8"?>
<msg brief="企点结构化消息" serviceID="115" background="#FFFFFFFF">
    <linear background="#FFFFFFFF" orientation="vertical">
        <linear margin="0,0,0,2" margin.pc="0,0,0,1">
            <linear action="browser" actionData="javascript:;">
                <image name="onlineGoods1" width="286" height="286" width.pc="143" height.pc="143" src="https://cdn.cglao.com/forum/202110/19/141734b00b09vosa9so6so.jpg"/>
            </linear>
            <linear margin="2,0,0,0" margin.pc="1,0,0,0" action="browser" actionData="javascript:;">
                <image name="onlineGoods2" width="284" height="286" width.pc="142" height.pc="143" src="https://cdn.cglao.com/forum/202110/19/141735sdxhxddt4xb1doxp.jpg"/>
            </linear>
        </linear>
        <linear>
            <linear action="browser" actionData="javascript:;">
                <image name="onlineGoods3" width="286" height="286" width.pc="143" height.pc="143" src="https://cdn.cglao.com/forum/202110/19/141736e12i20j7cvzji110.jpg"/>
            </linear>
            <linear margin="2,0,0,0" margin.pc="1,0,0,0" action="browser" actionData="javascript:;">
                <image name="onlineGoods4" width="284" height="286" width.pc="142" height.pc="143" src="https://img.tukuppt.com/png_preview/00/37/77/1w0VPk48OO.jpg!/fw/780"/>
            </linear>
        </linear>
        <linear action="browser" actionData="https://order.jd.com/center/list.action">
            <linear orientation="vertical" margin="24,20,24,24" margin.pc="12,10,12,12">
                <text width="524" size="32" width.pc="262" size.pc="14" color="#FF262d3d" color.pc="0xFF262d3d"
                 style="bold" maxLine="1" text="店铺上新抢先看" />
                <text width="524" margin="0,16,0,0" size="28" width.pc="262" margin.pc="0,8,0,0" size.pc="10"
                 color="#FF262d3d" color.pc="0xFF262d3d" maxLine="2" text="最近上新的商品，给最亲爱的你，最奢华的享受！" />
            </linear>
        </linear>
    </linear>
</msg>`;
// 气泡列表
export const robotBubble = `<?xml version="1.0" encoding="utf-8"?>
<msg brief="企点结构化消息" serviceID="115" background="#FFFFFFFF">
    <linear background="#FFFFFFFF" cornerRadius="12" width="-2" height="-2" orientation="vertical">
        <linear width="-2" height="-2" margin="0,8,0,8" orientation="vertical" platform="web">
            <linear width="-2" height="-2" margin="24,16,24,16" action="browser" actionData="javascript:;">
                <image name="onelineGoodsWeb0" width="112" height="112" src="https://cdn.pixabay.com/photo/2020/05/15/08/28/switch-5172817_1280.png"></image>
                <linear width="-2" height="-2" margin="20,8,0,0" orientation="vertical">
                    <linear width="-2" height="-2" margin="0,0,0,20" gravity="left|centerVertical">
                        <text height="-2" width="280" size="28" color="#FF262d3d" maxLine="1" text="智能手表1111" gravity="left|centerVertical"></text>
                        <text height="-2" width="116" size="32" color="#FFF75559" maxLine="1" style="bold" text="¥999.99" gravity="right|centerVertical"></text>
                    </linear>
                    <linear width="-2" height="-2">
                        <text height="-2" width="280" size="24" text="库存:20" maxLine="1" color="#FFA1ABC2" gravity="left|centerVertical"></text>
                        <text height="-2" width="116" size="24" text="销量:5" maxLine="1" color="#FFA1ABC2" gravity="right|centerVertical"></text>
                    </linear>
                </linear>
            </linear>
            <linear width="-2" height="-2" margin="24,16,24,16" action="browser" actionData="javascript:;">
                <image name="onelineGoodsWeb1" width="112" height="112" src="https://creazilla-store.fra1.digitaloceanspaces.com/cliparts/37997/playstation-vita-ps-clipart-md.png"></image>
                <linear width="-2" height="-2" margin="20,8,0,0" orientation="vertical">
                    <linear width="-2" height="-2" margin="0,0,0,20" gravity="left|centerVertical">
                        <text height="-2" width="280" size="28" color="#FF262d3d" maxLine="1" text="智能手表222" gravity="left|centerVertical"></text>
                        <text height="-2" width="116" size="32" color="#FFF75559" maxLine="1" style="bold" text="¥999.99" gravity="right|centerVertical"></text>
                    </linear>
                    <linear width="-2" height="-2">
                        <text height="-2" width="280" size="24" text="库存:20" maxLine="1" color="#FFA1ABC2" gravity="left|centerVertical"></text>
                        <text height="-2" width="116" size="24" text="销量:5" maxLine="1" color="#FFA1ABC2" gravity="right|centerVertical"></text>
                    </linear>
                </linear>
            </linear>
        </linear>
    </linear>
</msg>`;
// 横滑卡片消息
export const robotSlide =  {
  type: 18,
  content: [
    {
      id: '1',
      title: '智能手表1111',
      currencyUnit: '$',
      indicate: '4G全网通｜八重安全定位',
      price: '999.99',
      inventory: '20',
      sales: '5',
      image: 'https://cdn.pixabay.com/photo/2020/05/15/08/28/switch-5172817_1280.png',
      jumpURL: 'https://item.jd.com/100011203359.html',
    },
    {
      id: '2',
      title: '智能手表222',
      currencyUnit: '$',
      indicate: '4G全网通｜八重安全定位',
      price: '999.99',
      inventory: '20',
      sales: '5',
      image: 'https://cdn.pixabay.com/photo/2020/05/15/08/28/switch-5172817_1280.png',
      jumpURL: 'https://item.jd.com/100011203359.html?_need_qd_trans_info=1&a=1',
    },
    {
      id: '3',
      title: '智能手表3',
      currencyUnit: '$',
      indicate: '4G全网通｜八重安全定位',
      price: '999.99',
      inventory: '20',
      sales: '5',
      image: 'https://cdn.pixabay.com/photo/2020/05/15/08/28/switch-5172817_1280.png',
      jumpURL: 'https://www.baidu.com/?_need_qd_trans_info=1',
    },
    {
      id: '4',
      title: '智能手表4',
      currencyUnit: '$',
      indicate: '4G全网通｜八重安全定位',
      price: '999.99',
      inventory: '20',
      sales: '5',
      image: 'https://cdn.pixabay.com/photo/2020/05/15/08/28/switch-5172817_1280.png',
      jumpURL: 'https://www.baidu.com/?a=1',
    },
    // {
    //   id: '5',
    //   title: '智能手表4',
    //   currencyUnit: '$',
    //   indicate: '4G全网通｜八重安全定位',
    //   price: '999.99',
    //   inventory: '20',
    //   sales: '5',
    //   image: 'http://image.it168.com/n/640x480/4/4869/4869316.jpg',
    //   jumpURL: 'https://item.jd.com/100011203359.html',
    // },
  ],
};

